// utils/requireAuth.ts
import { redirect } from '@tanstack/react-router';
import userManager  from './authService';
import { getApiKey } from './apiKeyService';

export async function requireAuth() {
  if (getApiKey()) {
    return null;
  }

  const user = await userManager.getUser();
  if (!user || user.expired) {
    //await userManager.signinRedirect();
    throw redirect({ to: '/auth/login' }); // Temporarily redirect to login placeholder
  }
  return user;
}